/**
 * Polyfill stable language features. These imports will be optimized by `@babel/preset-env`.
 *
 * See: https://github.com/zloirock/core-js#babel
 */
import 'core-js/stable'
import 'regenerator-runtime/runtime'

import { setTwoToneColor } from '@ant-design/icons'
import { colours } from '@qflow/theme'

if (typeof (window as any).require === 'undefined') {
  ;(window as any).require = function () {
    throw Error('require() is not available in browser context')
  }
}
setTwoToneColor(colours.TEAL)

// Augment forwardRef typings to support underlying generic components like Antd.Select
// https://fettblog.eu/typescript-react-generic-forward-refs/#option-3%3A-augment-forwardref
declare module 'react' {
  // eslint-disable-next-line @typescript-eslint/no-empty-object-type
  function forwardRef<T, P = {}>(
    render: (props: P, ref: React.Ref<T>) => React.ReactElement | null
  ): (props: P & React.RefAttributes<T>) => React.ReactElement | null
}
